import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import axios from "axios";
import _ from "lodash";

import { CLOCK_TABLE_CONFIG, WEATHER_TABLE_CONFIG } from "../Constants/datatables";
import { useDataTableContext } from "../pages/Contexts/DataTableContext";
import { resetClockStates, setClockDisplay, setClockSettings, setIsEditingWeather } from "../redux/Slices/Apps/appsSlice";
import { handleResErrors, useInvalidateCampaignLayer } from "./utils";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import { toggleDialog } from "../redux/Slices/Global/globalSlice";
import axiosInstance from "../config/Axios";
import { FLIP_CLOCK_SETTINGS } from "../Constants/clock";

const BASE_URL = process.env.REACT_APP_NOT_SECRET_CODE

//--------------------------Read TimeZones--------------------------
const readTimezones = async (payload) => {
    const { data } = await axiosInstance.post("/clock/timezone/read", payload, {
        headers: {
            'Authorization': `Bearer ${payload?.token || localStorage.getItem("access_token")}`,
        },
    });
    return data;
}

export const useReadTimezones = () => {
    const { showToast } = useCustomToast();

    return useMutation(readTimezones, {
        onSuccess: () => { },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------Read oneTimeZones--------------------------
const readOneTimezones = async (payload) => {
    const { data } = await axios.post(`${BASE_URL}/clock/timezone/read/time`, payload, {
        headers: {
            'Authorization': `Bearer ${payload?.token || localStorage.getItem("access_token")}`,
        },
    });
    return data;
}

export const useReadOneTimezones = (payload) => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()

    return useQuery(
        ['readOneTimezones', payload],
        () => readOneTimezones(payload),
        {
            enabled: !!payload?.media_id && !!payload?.token,
            onSuccess: (data) => {
                dispatch(setClockDisplay(data.media.clock.display))
                dispatch(setClockSettings(data.media.clock.clock_settings))
            },
            onError: (error) => handleResErrors(error, showToast)
        }
    );
}




//--------------------------Create clock--------------------------
const createClock = async (payload) => {
    const { data } = await axiosInstance.post("/clock/create", payload);
    return data.data;
}

export const useCreateClockMutation = () => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()
    const { setLazyParams } = useDataTableContext();

    return useMutation(createClock, {
        onSuccess: async (data) => {
            dispatch(toggleDialog("ClockDialog"))
            dispatch(resetClockStates())
            showToast('success', "Clock Handling", data?.msg);
            setLazyParams(prev => ({ ...prev, ...CLOCK_TABLE_CONFIG }))
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}



//--------------------------Update clock--------------------------
const updateClock = async (payload) => {
    const { data } = await axiosInstance.post(`/clock/${payload?.id}/update`, payload);

    return data.data;
}

export const useUpdateClockMutation = () => {
    const { showToast } = useCustomToast();
    const { setLazyParams } = useDataTableContext();
    const dispatch = useDispatch()
    const invalidateCampaignLayer = useInvalidateCampaignLayer();
    const pathName = window.location.pathname;

    return useMutation(updateClock, {
        onSuccess: async (data) => {
            setLazyParams(prev => ({ ...prev, ...CLOCK_TABLE_CONFIG }))
            dispatch(resetClockStates())
            showToast('success', "Clock Handling", data?.msg);
            if (pathName.includes('campaign') || pathName.includes('layouts')) {
                invalidateCampaignLayer()
            }
            dispatch(toggleDialog("ClockDialog"))
        },
        onError: (error) => handleResErrors(error, showToast)

    })
}





// //--------------------------Read TimeZones external--------------------------
// const readWeatherExternal = async ({ queryKey }) => {
//     const [_key, payload] = queryKey;
//     const response = await axios.post(`${BASE_URL}/weather/read`, payload, {
//         headers: {
//             'Authorization': `Bearer ${payload?.token || localStorage.getItem("access_token")}`,
//         },
//     });
//     return response.data;
// };



// export const useReadWeatherExternal = (payload) => {
//     return useQuery({
//         queryKey: ['readWeatherExternal', payload],
//         queryFn: readWeatherExternal,
//         refetchInterval: 24 * 60 * 60 * 1000, // 24 hours  
//         enabled: !!payload?.media_id && !!payload?.token,
//     });
// };





//--------------------------Read Time--------------------------


// const readTime = async (payload) => {
//     const { data } = await axiosInstance.post("/clock/timezone/read/time", payload);
//     return data;
// }

// export const useReadTime = () => {
//     const { showToast } = useCustomToast();

//     return useMutation(readTime, {
//         onError: () => { showToast("error", "Error", "Failed to fetch RSS feed!") }
//     })
// }
